module.exports = __webpack_public_path__ + "img/ic-close.ec59d93f.svg";